import axios from '../utils/index';
import { Pat } from '@/typings/request';

/**
 * Admin-side API for the B2B revenue split. Matches Java controller
 * `B2bCommissionRateController` (@RequestMapping("/b2b-commission-rate")).
 *
 * Snowflake IDs travel as strings to avoid JavaScript precision loss.
 */
const b2bCommissionRatesApi = {
    /** Every configured rate, most specific scope first. */
    async getList() {
        return axios.get(`/b2b-commission-rate/list`);
    },

    async createRate(data: Pat) {
        return axios.post(`/b2b-commission-rate`, data);
    },

    async updateRate(b2bCommissionRateId: string, data: Pat) {
        return axios.put(`/b2b-commission-rate/${b2bCommissionRateId}`, data);
    },

    /** Soft-delete. The global default is rejected server-side — something must always apply. */
    async deleteRate(b2bCommissionRateId: string) {
        return axios.delete(`/b2b-commission-rate/${b2bCommissionRateId}`);
    },
};

export default b2bCommissionRatesApi;
